import { useMemo } from 'react';

import { useMenuCategories } from '../../../../api/hooks/menu-categories/useMenuCategories';
import {
  getMenuCategoryColumnDefinition,
  MENU_CATEGORY_TABS
} from '../../../../schema/menu/category/menu-category.schema';
import { EntityTable } from '../../../common/entity-table/EntityTable';

export const MenuCategoryTable = () => {
  const menuCategoriesQuery = useMenuCategories();

  const tabs = useMemo(
    () => MENU_CATEGORY_TABS(menuCategoriesQuery?.icons ?? []),
    [menuCategoriesQuery]
  );

  return (
    <EntityTable
      query={menuCategoriesQuery}
      getColumnDefinition={getMenuCategoryColumnDefinition}
      entityTabs={tabs}
      entityName="Menu Category"
      canExport={false}
    />
  );
};
